import * as variables from './variables';

export default variables;
